import { apiGet, apiPost, apiPut } from 'helpers/ApiHelper';
import * as notificationActions from './notificationActions';
import { toDate, objectToQuery } from 'helpers/Formatter';

import Auth from 'j-toker';

export function getProspectStats() {
  const route = '/landlords/prospect_stats';
  return dispatch => {
    return dispatch({
      type: 'PROSPECTS::FETCH_PROSPECTS_STATS',
      payload: apiGet(Auth.getApiUrl() + route).done(response => {
        dispatch({
          type: 'PROSPECTS::SAVE_PROSPECTS_STATS',
          payload: response.detailed_prospects_counts,
        });
      }),
    });
  };
}

export function getFilteredProspects(subset = 'all', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: 'PROSPECTS::FETCH_PROSPECTS',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/filtered_prospects?subset=${subset}&offset=${offset}`,
        options
      )
        .done(response => {
          dispatch(displayProspects(response.prospects, Date.now(), offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getProspects(options) {
  // Options: show_all: true will return list of all tenants.
  let route = '/landlords/detailed_prospects';
  if (options) {
    route += objectToQuery(options);
  }
  return dispatch => {
    return dispatch({
      type: 'PROSPECTS::FETCH_PROSPECTS',
      payload: apiGet(Auth.getApiUrl() + route)
        .done(response => {
          dispatch(displayProspects(response.prospects, Date.now(), options.offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getProspectDetails(prospectId) {
  // Options: show_all: true will return list of all tenants.
  let route = `/landlords/prospects/${prospectId}`;
  return dispatch => {
    return dispatch({
      type: 'PROSPECTS::FETCH_PROSPECT',
      payload: apiGet(Auth.getApiUrl() + route)
        .done(response => {
          dispatch(displayProspect(response.prospect));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function displayProspect(response) {
  if (response['birthday']) {
    response['dob'] = toDate(response['birthday']);
  }

  if (response['move_in_date']) {
    response['move_in_date'] = toDate(response['move_in_date']);
  }
  return {
    type: 'PROSPECTS::SHOW_PROSPECT',
    prospect: response,
  };
}

export function displayProspects(response, timestamp, offset) {
  return {
    type: 'PROSPECTS::SHOW_PROSPECTS',
    prospects: response,
    timestamp,
    offset,
  };
}

export function updateProspect(data, prospectId) {
  const route = `/landlords/lead_cards/${prospectId}`;

  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + route, data)
        .done(response => {})
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}
